import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  VStack,
  Text,
  HStack,
} from "@chakra-ui/react";
import { PrimaryButton } from "components/Button";
import SecondaryButton from "components/Button/BrandOutlineButton";
import CaminoWarningTriangle from "components/Icon/CaminoWarningTriangle";

interface RecurringMeetingWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  changedFields: string[];
}

export default function RecurringMeetingWarningModal({
  isOpen,
  onClose,
  onConfirm,
  changedFields,
}: RecurringMeetingWarningModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <HStack spacing={2}>
            <CaminoWarningTriangle stroke="cdsOrange.500" />
            <Text>Update Recurring Meeting</Text>
          </HStack>
        </ModalHeader>
        <ModalBody>
          <VStack align="start" spacing={3}>
            <Text>
              You are about to update a recurring meeting that has already been scheduled.
              The following changes will be applied to all future occurrences:
            </Text>
            <VStack align="start" pl={4} spacing={1}>
              {changedFields.map((field) => (
                <Text key={field} fontSize="sm" color="content.primary">
                  •
                  {" "}
                  {field}
                </Text>
              ))}
            </VStack>
            <Text fontSize="sm" color="content.primary">
              Past occurrences will not be affected by these changes.
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <HStack spacing={3}>
            <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
            <PrimaryButton onClick={onConfirm}>Continue</PrimaryButton>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
